/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import { MobileMenu } from "./mobile_menu";
import { MobileBackDrop } from "./mobile_menu/mobile-backdrop";
import { PrimaryMenu } from "./primary_menu";
import { TopBar } from "./top_bar";
import { AlertBanner } from "layout-components/alert-banner";
import { useMedia } from "react-use";
import { useSimpliCity } from "cms/hooks/use-simplicity";

const Header = () => {
    // const [showMobileMenu, setShowMobileMenu] = useState(false);
    const isDesktop = useMedia("screen and (min-width: 1125px)");
    const { showMobileMenu, setShowMobileMenu } = useSimpliCity();

    const toggleMobile = () => {
        setShowMobileMenu(!showMobileMenu);
    };

    return (
        <header className="header">
            <AlertBanner />

            {isDesktop && <TopBar />}

            <PrimaryMenu toggleMobile={toggleMobile} show={showMobileMenu} />

            <MobileMenu show={showMobileMenu} />

            {!isDesktop && <TopBar />}
            {showMobileMenu && <MobileBackDrop toggleMobile={toggleMobile} />}
        </header>
    );
};

export { Header };
